import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BreadcrumbsModule } from "src/app/components/elementi-strutturali/breadcrumbs/breadcrumbs.module";
import { SocialShareComponent } from "src/app/shared/components/social-share/social-share.component";
import { SharedModuleModule } from "src/app/shared/shared-module/shared-module.module";
import { PublicDocumentLayoutComponent } from "./public-document-layout.component";
import { ActionsListComponent } from "src/app/shared/components/actions-list/actions-list.component";

@NgModule({
  imports: [CommonModule, BreadcrumbsModule, SharedModuleModule, RouterModule, FormsModule, SocialShareComponent, ActionsListComponent],
  declarations: [PublicDocumentLayoutComponent],
  exports: [PublicDocumentLayoutComponent],

})
export class PublicDocumentLayoutModule {
  static component = PublicDocumentLayoutComponent
}